import { Injectable } from '@angular/core';
import { GLOBAL } from '../global';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProvinceService {

  urlBase: string;

  /**
   * @author Frank Edward Daza González
   * @version 2018-10-30
   * @param httpClient
   */
  constructor(private httpClient: HttpClient) {
    this.urlBase = GLOBAL.URL_SIGAMOS + 'sicaProvince';
  }

  /**
    * Retorna las provincias del servicio REST de SIGAMOS.
    * 
    * @author Frank Edward Daza González
    * @version 2018-10-30
    */
   getProvinces(): Observable<any> {
    return this.httpClient.get(this.urlBase + '/getProvinces');
  }

}
